module.exports = __webpack_public_path__ + "img/1393729097.bfe4b067.jpg";